import React, { useState } from 'react'
    import { Filter, Star, Sparkles, Heart, Code, Users, Zap, Lightbulb } from 'lucide-react'

    const Services = () => {
      const [selectedCategory, setSelectedCategory] = useState('all')
      const [selectedLevel, setSelectedLevel] = useState('all')
      const [selectedFormat, setSelectedFormat] = useState('all')

      const categories = [
        { id: 'all', name: 'All Services', emoji: '🚀' },
        { id: 'learning', name: 'Learning Programs', emoji: '📚' },
        { id: 'consulting', name: 'Consulting', emoji: '💡' },
        { id: 'workshops', name: 'Workshops', emoji: '🎯' },
        { id: 'support', name: 'Support', emoji: '🤝' }
      ]

      const levels = [
        { id: 'all', name: 'All Levels', emoji: '🌟' },
        { id: 'beginner', name: 'Beginner', emoji: '🌱' },
        { id: 'intermediate', name: 'Intermediate', emoji: '🌿' },
        { id: 'advanced', name: 'Advanced', emoji: '🌳' },
        { id: 'expert', name: 'Expert', emoji: '🏆' }
      ]

      const formats = [
        { id: 'all', name: 'All Formats', emoji: '📋' },
        { id: 'online', name: 'Online', emoji: '💻' },
        { id: 'in-person', name: 'In-Person', emoji: '🏢' },
        { id: 'hybrid', name: 'Hybrid', emoji: '🔄' },
        { id: 'self-paced', name: 'Self-Paced', emoji: '⏰' }
      ]

      const services = [
        // Learning Programs
        {
          id: 1,
          name: 'Vibe Coding Fundamentals',
          description: 'Learn the basics of coding through our revolutionary vibe methodology',
          price: 299,
          category: 'learning',
          level: 'beginner',
          format: ['online', 'self-paced'],
          image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.9,
          duration: '8 weeks'
        },
        {
          id: 2,
          name: 'Visual Programming Mastery',
          description: 'Master visual programming concepts with interactive learning',
          price: 499,
          category: 'learning',
          level: 'intermediate',
          format: ['online', 'hybrid'],
          image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.8,
          duration: '12 weeks'
        },
        {
          id: 3,
          name: 'Web Development for Non-Techies',
          description: 'Build beautiful websites without the technical jargon',
          price: 399,
          category: 'learning',
          level: 'beginner',
          format: ['online', 'in-person'],
          image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.7,
          duration: '10 weeks'
        },
        // Consulting
        {
          id: 4,
          name: 'Personal Coding Mentor',
          description: 'One-on-one guidance tailored to your learning style and goals',
          price: 150,
          category: 'consulting',
          level: 'beginner',
          format: ['online', 'in-person'],
          image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 5.0,
          duration: 'Per hour'
        },
        {
          id: 5,
          name: 'Business Automation Consulting',
          description: 'Transform your business processes with custom coding solutions',
          price: 200,
          category: 'consulting',
          level: 'intermediate',
          format: ['online', 'in-person'],
          image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.9,
          duration: 'Per hour'
        },
        // Workshops
        {
          id: 6,
          name: 'Weekend Coding Bootcamp',
          description: 'Intensive weekend workshop to jumpstart your coding journey',
          price: 199,
          category: 'workshops',
          level: 'beginner',
          format: ['in-person', 'hybrid'],
          image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.6,
          duration: '2 days'
        },
        {
          id: 7,
          name: 'Mobile App Creation Workshop',
          description: 'Build your first mobile app using visual programming tools',
          price: 249,
          category: 'workshops',
          level: 'intermediate',
          format: ['online', 'in-person'],
          image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.8,
          duration: '1 day'
        },
        // Support
        {
          id: 8,
          name: 'Community Access',
          description: 'Join our vibrant community of non-tech coders',
          price: 29,
          category: 'support',
          level: 'beginner',
          format: ['online'],
          image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.5,
          duration: 'Monthly'
        },
        {
          id: 9,
          name: 'Priority Support Package',
          description: 'Get priority help when you need it most',
          price: 99,
          category: 'support',
          level: 'intermediate',
          format: ['online'],
          image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
          rating: 4.7,
          duration: 'Monthly'
        }
      ]

      const filteredServices = services.filter(service => {
        const categoryMatch = selectedCategory === 'all' || service.category === selectedCategory
        const levelMatch = selectedLevel === 'all' || service.level === selectedLevel
        const formatMatch = selectedFormat === 'all' || service.format.includes(selectedFormat)
        
        return categoryMatch && levelMatch && formatMatch
      })

      return (
        <div data-component-path="client/src/pages/Menu.jsx" data-component-line="1:4" data-component-id="client/src/pages/Menu.jsx:1:4" className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50">
          {/* Hero Section */}
          <section 
            data-component-path="client/src/pages/Menu.jsx" data-component-line="2:6" data-component-id="client/src/pages/Menu.jsx:2:6"
            className="relative h-80 bg-cover bg-center overflow-hidden"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80)'
            }}
          >
            <div data-component-path="client/src/pages/Menu.jsx" data-component-line="3:8" data-component-id="client/src/pages/Menu.jsx:3:8" className="absolute inset-0 bg-gradient-to-r from-orange-900/70 via-pink-900/70 to-purple-900/70"></div>
            <div data-component-path="client/src/pages/Menu.jsx" data-component-line="4:8" data-component-id="client/src/pages/Menu.jsx:4:8" className="relative z-10 flex items-center justify-center h-full">
              <div data-component-path="client/src/pages/Menu.jsx" data-component-line="5:10" data-component-id="client/src/pages/Menu.jsx:5:10" className="text-center text-white">
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="6:12" data-component-id="client/src/pages/Menu.jsx:6:12" className="flex items-center justify-center mb-6">
                  <Code data-component-path="client/src/pages/Menu.jsx" data-component-line="7:14" data-component-id="client/src/pages/Menu.jsx:7:14" className="h-10 w-10 text-orange-300 mr-4 animate-pulse" />
                  <h1 data-component-path="client/src/pages/Menu.jsx" data-component-line="8:14" data-component-id="client/src/pages/Menu.jsx:8:14" className="font-display text-6xl font-bold drop-shadow-lg">Our Services</h1>
                  <Code data-component-path="client/src/pages/Menu.jsx" data-component-line="9:14" data-component-id="client/src/pages/Menu.jsx:9:14" className="h-10 w-10 text-pink-300 ml-4 animate-pulse" style={{ animationDelay: '0.5s' }} />
                </div>
                <p data-component-path="client/src/pages/Menu.jsx" data-component-line="10:12" data-component-id="client/src/pages/Menu.jsx:10:12" className="text-2xl drop-shadow-md">Discover how we make coding accessible for everyone ✨</p>
              </div>
            </div>
          </section>

          {/* Filters */}
          <section data-component-path="client/src/pages/Menu.jsx" data-component-line="11:6" data-component-id="client/src/pages/Menu.jsx:11:6" className="py-12 bg-white/80 backdrop-blur-sm shadow-xl border-b-4 border-gradient-to-r from-orange-200 to-pink-200">
            <div data-component-path="client/src/pages/Menu.jsx" data-component-line="12:8" data-component-id="client/src/pages/Menu.jsx:12:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div data-component-path="client/src/pages/Menu.jsx" data-component-line="13:10" data-component-id="client/src/pages/Menu.jsx:13:10" className="flex items-center justify-center mb-10">
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="14:12" data-component-id="client/src/pages/Menu.jsx:14:12" className="bg-gradient-to-r from-orange-500 to-pink-500 p-3 rounded-2xl shadow-lg">
                  <Filter data-component-path="client/src/pages/Menu.jsx" data-component-line="15:14" data-component-id="client/src/pages/Menu.jsx:15:14" className="h-6 w-6 text-white" />
                </div>
                <h2 data-component-path="client/src/pages/Menu.jsx" data-component-line="16:12" data-component-id="client/src/pages/Menu.jsx:16:12" className="text-3xl font-bold text-gray-900 ml-4">Find Your Perfect Service</h2>
              </div>

              <div data-component-path="client/src/pages/Menu.jsx" data-component-line="17:10" data-component-id="client/src/pages/Menu.jsx:17:10" className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Category Filter */}
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="18:12" data-component-id="client/src/pages/Menu.jsx:18:12" className="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-lg border-2 border-orange-100">
                  <label data-component-path="client/src/pages/Menu.jsx" data-component-line="19:14" data-component-id="client/src/pages/Menu.jsx:19:14" className="block text-lg font-bold text-gray-900 mb-4">Service Type</label>
                  <div data-component-path="client/src/pages/Menu.jsx" data-component-line="20:14" data-component-id="client/src/pages/Menu.jsx:20:14" className="flex flex-wrap gap-3">
                    {categories.map(category => (
                      <button
                        data-component-path="client/src/pages/Menu.jsx" data-component-line="21:16" data-component-id="client/src/pages/Menu.jsx:21:16"
                        key={category.id}
                        onClick={() => setSelectedCategory(category.id)}
                        className={`filter-button px-4 py-3 rounded-xl text-sm font-bold transition-all flex items-center space-x-2 ${
                          selectedCategory === category.id
                            ? 'active text-white shadow-lg'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-transparent hover:border-orange-200'
                        }`}
                      >
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="22:18" data-component-id="client/src/pages/Menu.jsx:22:18">{category.emoji}</span>
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="23:18" data-component-id="client/src/pages/Menu.jsx:23:18">{category.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Level Filter */}
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="24:12" data-component-id="client/src/pages/Menu.jsx:24:12" className="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-lg border-2 border-pink-100">
                  <label data-component-path="client/src/pages/Menu.jsx" data-component-line="25:14" data-component-id="client/src/pages/Menu.jsx:25:14" className="block text-lg font-bold text-gray-900 mb-4">Experience Level</label>
                  <div data-component-path="client/src/pages/Menu.jsx" data-component-line="26:14" data-component-id="client/src/pages/Menu.jsx:26:14" className="flex flex-wrap gap-3">
                    {levels.map(level => (
                      <button
                        data-component-path="client/src/pages/Menu.jsx" data-component-line="27:16" data-component-id="client/src/pages/Menu.jsx:27:16"
                        key={level.id}
                        onClick={() => setSelectedLevel(level.id)}
                        className={`filter-button px-4 py-3 rounded-xl text-sm font-bold transition-all flex items-center space-x-2 ${
                          selectedLevel === level.id
                            ? 'active text-white shadow-lg'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-transparent hover:border-pink-200'
                        }`}
                      >
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="28:18" data-component-id="client/src/pages/Menu.jsx:28:18">{level.emoji}</span>
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="29:18" data-component-id="client/src/pages/Menu.jsx:29:18">{level.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Format Filter */}
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="30:12" data-component-id="client/src/pages/Menu.jsx:30:12" className="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-lg border-2 border-purple-100">
                  <label data-component-path="client/src/pages/Menu.jsx" data-component-line="31:14" data-component-id="client/src/pages/Menu.jsx:31:14" className="block text-lg font-bold text-gray-900 mb-4">Format</label>
                  <div data-component-path="client/src/pages/Menu.jsx" data-component-line="32:14" data-component-id="client/src/pages/Menu.jsx:32:14" className="flex flex-wrap gap-3">
                    {formats.map(format => (
                      <button
                        data-component-path="client/src/pages/Menu.jsx" data-component-line="33:16" data-component-id="client/src/pages/Menu.jsx:33:16"
                        key={format.id}
                        onClick={() => setSelectedFormat(format.id)}
                        className={`filter-button px-4 py-3 rounded-xl text-sm font-bold transition-all flex items-center space-x-2 ${
                          selectedFormat === format.id
                            ? 'active text-white shadow-lg'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-transparent hover:border-purple-200'
                        }`}
                      >
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="34:18" data-component-id="client/src/pages/Menu.jsx:34:18">{format.emoji}</span>
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="35:18" data-component-id="client/src/pages/Menu.jsx:35:18">{format.name}</span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Services Grid */}
          <section data-component-path="client/src/pages/Menu.jsx" data-component-line="36:6" data-component-id="client/src/pages/Menu.jsx:36:6" className="py-16">
            <div data-component-path="client/src/pages/Menu.jsx" data-component-line="37:8" data-component-id="client/src/pages/Menu.jsx:37:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div data-component-path="client/src/pages/Menu.jsx" data-component-line="38:10" data-component-id="client/src/pages/Menu.jsx:38:10" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                {filteredServices.map(service => (
                  <div data-component-path="client/src/pages/Menu.jsx" data-component-line="39:12" data-component-id="client/src/pages/Menu.jsx:39:12" key={service.id} className="menu-card bg-white rounded-3xl shadow-xl overflow-hidden">
                    <div data-component-path="client/src/pages/Menu.jsx" data-component-line="40:14" data-component-id="client/src/pages/Menu.jsx:40:14" className="relative">
                      <img
                        data-component-path="client/src/pages/Menu.jsx" data-component-line="41:16" data-component-id="client/src/pages/Menu.jsx:41:16"
                        src={service.image}
                        alt={service.name}
                        className="w-full h-56 object-cover"
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
                        }}
                      />
                      <div data-component-path="client/src/pages/Menu.jsx" data-component-line="42:16" data-component-id="client/src/pages/Menu.jsx:42:16" className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-2xl px-3 py-2 flex items-center space-x-2 shadow-lg">
                        <Star data-component-path="client/src/pages/Menu.jsx" data-component-line="43:18" data-component-id="client/src/pages/Menu.jsx:43:18" className="h-5 w-5 text-yellow-500 fill-current" />
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="44:18" data-component-id="client/src/pages/Menu.jsx:44:18" className="text-sm font-bold text-gray-900">{service.rating}</span>
                      </div>
                      <div data-component-path="client/src/pages/Menu.jsx" data-component-line="45:16" data-component-id="client/src/pages/Menu.jsx:45:16" className="absolute top-4 left-4 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-2xl px-3 py-2 shadow-lg">
                        <Heart data-component-path="client/src/pages/Menu.jsx" data-component-line="46:18" data-component-id="client/src/pages/Menu.jsx:46:18" className="h-5 w-5 fill-current" />
                      </div>
                    </div>
                    
                    <div data-component-path="client/src/pages/Menu.jsx" data-component-line="47:14" data-component-id="client/src/pages/Menu.jsx:47:14" className="p-8">
                      <div data-component-path="client/src/pages/Menu.jsx" data-component-line="48:16" data-component-id="client/src/pages/Menu.jsx:48:16" className="flex justify-between items-start mb-3">
                        <h3 data-component-path="client/src/pages/Menu.jsx" data-component-line="49:18" data-component-id="client/src/pages/Menu.jsx:49:18" className="text-2xl font-bold text-gray-900">{service.name}</h3>
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="50:18" data-component-id="client/src/pages/Menu.jsx:50:18" className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">${service.price}</span>
                      </div>
                      
                      <p data-component-path="client/src/pages/Menu.jsx" data-component-line="51:16" data-component-id="client/src/pages/Menu.jsx:51:16" className="text-gray-700 mb-4 text-lg leading-relaxed">{service.description}</p>
                      
                      <div data-component-path="client/src/pages/Menu.jsx" data-component-line="52:16" data-component-id="client/src/pages/Menu.jsx:52:16" className="flex items-center justify-between mb-6">
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="53:18" data-component-id="client/src/pages/Menu.jsx:53:18" className="px-3 py-2 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-sm rounded-xl font-bold capitalize border-2 border-blue-200">
                          {service.level}
                        </span>
                        <span data-component-path="client/src/pages/Menu.jsx" data-component-line="54:18" data-component-id="client/src/pages/Menu.jsx:54:18" className="text-gray-600 font-medium">{service.duration}</span>
                      </div>
                      
                      <div data-component-path="client/src/pages/Menu.jsx" data-component-line="55:16" data-component-id="client/src/pages/Menu.jsx:55:16" className="flex flex-wrap gap-2">
                        {service.format.map(format => (
                          <span
                            data-component-path="client/src/pages/Menu.jsx" data-component-line="56:20" data-component-id="client/src/pages/Menu.jsx:56:20"
                            key={format}
                            className="px-3 py-2 bg-gradient-to-r from-green-100 to-green-200 text-green-800 text-sm rounded-xl font-bold capitalize border-2 border-green-200"
                          >
                            {format}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {filteredServices.length === 0 && (
                <div data-component-path="client/src/pages/Menu.jsx" data-component-line="57:10" data-component-id="client/src/pages/Menu.jsx:57:10" className="text-center py-16">
                  <div data-component-path="client/src/pages/Menu.jsx" data-component-line="58:12" data-component-id="client/src/pages/Menu.jsx:58:12" className="bg-white/80 backdrop-blur-sm rounded-3xl p-12 shadow-xl border-2 border-orange-100 max-w-md mx-auto">
                    <Sparkles data-component-path="client/src/pages/Menu.jsx" data-component-line="59:14" data-component-id="client/src/pages/Menu.jsx:59:14" className="h-16 w-16 text-orange-500 mx-auto mb-4" />
                    <p data-component-path="client/src/pages/Menu.jsx" data-component-line="60:14" data-component-id="client/src/pages/Menu.jsx:60:14" className="text-gray-700 text-xl font-medium">No services match your current filters. Try adjusting your selection! ✨</p>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      )
    }

    export default Services